/*
 * @Description: 销售订单有关语言包
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  销售订单: '销售订单',
  实缴信息: '实缴信息',
  新增订单: '新增订单',
  天: '天',
  查看: '查看',
  转移: '转移',
  基础字段: '基础字段',
  转移订单: '转移订单',
  编辑销售订单: '编辑销售订单',
  新增销售订单: '新增销售订单',
  销售订单管理: '销售订单管理',
  重置: '重置',
  提交: '提交',
  收起: '收起',
  展开: '展开',
  提交并按明细拆分: '提交并按明细拆分',
  基本信息: '基本信息',
  系统信息: '系统信息',
  订单明细: '订单明细',
  添加报价单明细: '添加报价单明细',
  添加合同明细: '添加合同明细',
  数据加载中: '数据加载中',
  操作失败: '操作失败',
  获取数据失败: '获取数据失败',
  编辑订单明细: '编辑订单明细',
  添加订单明细: '添加订单明细',
  请选择报价单: '请选择报价单',
  请选择销售合同: '请选择销售合同',
  添加明细: '添加明细',
  编辑: '编辑',
  复制: '复制',
  删除: '删除',
  加载中: '加载中',
  详细信息: '详细信息',
  审批记录: '审批记录',
  暂无此销售订单查看权限: '暂无此销售订单查看权限',
  关闭: '关闭',
  取消: '取消',
  确定: '确定',
  选择价格: '选择价格',
  已过期价格不可选: '已过期价格不可选',
  至: '至',
  标准价格: '标准价格：',
  币种: '币种',
  时长单位: '时长单位',
  规格单位: '规格单位',
  有效期: '有效期',
  请选择产品名称: '请选择产品名称',
  操作: '操作',
  提交成功: '提交成功',
  报价单是必填项: '报价单是必填项',
  PO单附件是必填项: 'PO单附件是必填项',
  审批编号: '审批编号',
  审批状态: '审批状态',
  拒绝理由: '拒绝理由',
  最后审批人: '最后审批人',
  最后审批时间: '最后审批时间',
  发起人: '发起人',
  发起时间: '发起时间'
};
